__turbopack_context__.v({
  "smsConsent": "LookupPhoneNumber-module__Ks5fDG__smsConsent",
});
